import { Component, Inject, OnInit } from '@angular/core';
import { FondeadoresService } from '../../../services/fondeadores.service';
import { HelpersService } from '../../../services/tools/helpers.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-eliminar-fondeador',
  templateUrl: './eliminar-fondeador.component.html',
  styleUrls: ['./eliminar-fondeador.component.scss']
})
export class EliminarFondeadorComponent implements OnInit {

  public esSocio: boolean = false;
  public errors: any = {};
  
  constructor(
    private service: FondeadoresService,
    private helperService: HelpersService,
    public dialogRef: MatDialogRef<EliminarFondeadorComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    var tempSocio = this.data.vistaSocio;
    if(tempSocio != undefined){
      this.esSocio= this.data.vistaSocio;
      console.log("Es socio");
      
    }
  }

  public aceptar(){
    console.log("ID: ",this.data);
    this.service.delete(this.data.idFondeador)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.helperService.notification('Fondeador eliminado', 'Se ha borrado exitosamente', 'success');
          //Poner dentro del success response
          this.dialogRef.close({eliminar:true});
          setTimeout(() => {window.location.reload()},3000);
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.dialogRef.close({eliminar:false});
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  public eliminarSocio(){
    this.dialogRef.close({eliminar:true});
  }

  public cerrar(){
    
    this.dialogRef.close({eliminar:false});
  }
  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/eliminar-fondeador/eliminar-fondeador.component.ts